import { render } from "./HamburgerMenuButton.vue?vue&type=template&id=4bf99433&scoped=true"
import script from "./HamburgerMenuButton.vue?vue&type=script&lang=js"
export * from "./HamburgerMenuButton.vue?vue&type=script&lang=js"

import "./HamburgerMenuButton.vue?vue&type=style&index=0&id=4bf99433&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf99433"]])

export default __exports__